{
  "odometerVelocityWarning": {
    "title": "Verificação de Quilometragem",
    "message": "A quilometragem que você inseriu sugere uma velocidade média de {{velocity}} km/h entre sessões. Isso está correto?",
    "previousOdometer": "Quilometragem anterior",
    "newOdometer": "Nova quilometragem",
    "difference": "Diferença",
    "timeDifference": "Diferença de tempo",
    "question": "Esta leitura de quilometragem está correta?",
    "confirm": "Sim, está correto"
  },
  "odometerCorrection": {
    "title": "Corrigir Quilometragem da Sessão Anterior",
    "message": "A quilometragem que você inseriu ({{new}} km) é inferior ao fim da sessão anterior ({{previous}} km). Deseja corrigir a quilometragem da sessão anterior?",
    "previousSession": "Sessão Anterior",
    "date": "Data",
    "currentOdometer": "Quilometragem atual",
    "correctedOdometerLabel": "Quilometragem corrigida (km)",
    "observationsLabel": "Observações (obrigatório)",
    "confirm": "Corrigir Sessão Anterior",
    "odometerRequired": "Por favor, insira um valor de quilometragem válido.",
    "odometerInvalid": "A quilometragem deve ser um número positivo.",
    "odometerTooHigh": "A quilometragem corrigida deve ser menor que {{previous}} km para permitir iniciar com {{new}} km.",
    "observationsRequired": "Por favor, forneça observações explicando a correção."
  }
}





